import React from 'react'
import Accordions from '../../../components/Accordions'


const Sem3Aiml = () =>{
  const data = [
    // {
    //   subjectName: "2021 Batch",
    //   units: [ ],
    //   links: [
    //     {
    //       url: "https://drive.google.com/file/d/14yOh6xfNNyrahege0g_oHDquYc-XA6GK/view?usp=sharing",
    //       title: "Syllabus",
    //     },
    //   ],
    // },
    {
      subjectName: "2022 Batch",
      units: [],
      links: [
        {
          url: "https://drive.google.com/file/d/14yOh6xfNNyrahege0g_oHDquYc-XA6GK/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">AIML Sem - 3</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem3Aiml